module.exports = __webpack_public_path__ + "static/media/squarespace.847b1f4c.svg";